module.exports = __webpack_public_path__ + "img/owl.78bb72ed.gif";